import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface IUnitOfMeasureModel extends IModel {
  unitOfMeasureId: number;
  name: string;
}

export class UnitOfMeasureModel
  extends Model
  implements ModelRecord<IUnitOfMeasureModel>
{
  unitOfMeasureId: number;
  name: string;

  constructor(params?: Partial<IUnitOfMeasureModel>) {
    super(params);
    this.unitOfMeasureId = defaultTo(params?.unitOfMeasureId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
